import React from "react";

export function PageHeader({ eyebrow, title, description, image }) {
  return (
    <section className="relative overflow-hidden bg-slate-950 text-white">
      {image && (
        <>
          <img
            src={image}
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-slate-950/40 via-slate-950/70 to-slate-950" />
        </>
      )}
      <div className="absolute inset-0 opacity-[0.08]" style={{
        backgroundImage:
          "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
        backgroundSize: "64px 64px",
      }} />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-20 lg:py-28">
        {eyebrow && (
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/15 bg-white/5 text-xs font-semibold text-brand-gold uppercase tracking-[0.2em] mb-6">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold leading-[0.95] tracking-tighter max-w-3xl">
          {title}
        </h1>
        {description && (
          <p className="text-base md:text-lg text-slate-300 max-w-2xl mt-6 leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
